module.exports = __webpack_public_path__ + "static/img/ent-detail-87.1661da1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/entpic/ent-detail-87.jpg
// module id = 6n8C
// module chunks = 51